import React, { KeyboardEvent, ChangeEvent } from "react";
import {
  Popover,
  TextField,
  InputAdornment,
  Divider,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { menuItemSx, menuPaperProps, textFieldSx } from "../style/editorStyles";
import { contextualMenuItems } from "../style/contextualMenuItems";

interface EditorPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  menuQuery: string;
  setMenuQuery: (value: string) => void;
  handleClose: () => void;
  handleSubmitInstruction: () => void;
  handleHighlight: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const EditorPopover: React.FC<EditorPopoverProps> = ({
  open,
  anchorEl,
  menuQuery,
  setMenuQuery,
  handleClose,
  handleSubmitInstruction,
  handleHighlight,
}) => (
  <Popover
    id="magic-popover"
    open={open}
    anchorEl={anchorEl}
    onClose={handleClose}
    PaperProps={menuPaperProps}
    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    transformOrigin={{ vertical: "top", horizontal: "left" }}
    keepMounted
    disableEnforceFocus
    disableAutoFocus
    disableRestoreFocus
  >
    <div
      onKeyDown={(e: KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "Escape") {
          e.stopPropagation();
          handleClose();
        }
      }}
      style={{ padding: 12, width: 300 }}
    >
      <TextField
        fullWidth
        size="small"
        value={menuQuery}
        onChange={(e: ChangeEvent<HTMLInputElement>) => setMenuQuery(e.target.value)}
        placeholder="Escribe una instrucción…"
        sx={textFieldSx}
        onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.stopPropagation();
            handleSubmitInstruction();
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#9BB6C3" }} />
            </InputAdornment>
          ),
        }}
      />
      <Divider sx={{ borderColor: "rgba(255,255,255,0.12)", mb: 0.5 }} />
      <List dense disablePadding>
        {contextualMenuItems.map(({ icon, text }) => (
          <ListItemButton key={text} onClick={handleHighlight} sx={menuItemSx}>
            <ListItemIcon sx={{ minWidth: 32, color: "inherit" }}>{icon}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItemButton>
        ))}
      </List>
    </div>
  </Popover>
);

export default EditorPopover;
